import type { PromotionAudience, PromotionConfig } from '@/modelsLocal/promotion-modal';
import { isEmptyFeatureConfig, type FeatureConfig } from '@/models/feature-config';
import OsterSpecialImage from '@/assets/images/promo/exclusive.jpeg';

// Beispiele für `audience`:
//   { exclude: ['communityMember'] }                              → alle außer Community-Member
//   { requireAll: ['chatbot'] }                                   → nur User mit Chatbot
//   { onlyWhenNoFeatures: true }                                  → nur Free-User ohne jegliche Features
//   { requireAny: ['coreRecommendations','swingTradeRecommendations'], exclude: ['communityMember'] }

export const PROMOTION_CONFIG: PromotionConfig = {
  title: 'Exklusiv-Upgrade',
  imageUrl: OsterSpecialImage, //Bild im Format 1:1
  shortDescription: 'Sichere dir 10% Rabatt auf dein Premium-Upgrade mit dem Code:',
  longDescription: 'Wir machen den Börsencampus exklusiver!\n' +
    '\n' +
    'Die Nachfrage nach unseren Tradingideen ist in den letzten Monaten enorm gewachsen — und genau deshalb setzen wir konsequent auf Qualität statt Masse.\n' +
    '\n' +
    'Damit du auch weiterhin fundierte Analysen, hochwertige Signale und eine persönliche Betreuung bekommst, konzentrieren wir uns ab sofort ganz auf unsere Premium-Mitglieder.\n' +
    '\n' +
    'Um die höchste Qualität sicherzustellen, bieten wir ab 01.05.2026 nur noch Premium-Accounts an.\n' +
    '\n' +
    'Als Dankeschön für deine Treue erhältst du mit dem Code PROMOX einen Rabatt von 10% auf deine Buchung.',
  couponCode: 'PROMOX', // Dein Gutscheincode
  activeFrom: new Date('2026-04-24T08:00:00'),//Dein Startdatum
  activeTo: new Date('2026-05-08T23:59:59'), // Dein Umstelldatum
  audience: { onlyWhenNoFeatures: true, exclude: ['communityMember']  }, // Zeigt es nur Usern ohne aktives Abo
};

export const LANDING_PROMOTION_CONFIG: PromotionConfig | null = null;
// export const LANDING_PROMOTION_CONFIG: PromotionConfig | null = {
//   title: 'Frohe Ostern',
//   imageUrl: OsterSpecialImage, //Bild im Format 1:1
//   shortDescription: 'Wir schenken dir 20% einmalig auf unsere Tradingideen. Nutze den Gutscheincode beim Checkout:',
//   longDescription: '🐣 Frohe Ostern vom Börsencampus!\n' +
//     '\n' +
//     'Wir wünschen dir schöne Feiertage und schenken dir 20% einmalig auf unsere Tradingideen.\n' +
//     '\n' +
//     'Frohe Ostern und viel Erfolg an der Börse! 📈',
//   couponCode: 'OSTERN20',
//   activeFrom: new Date('2026-04-03T00:00:00'),
//   activeTo: new Date('2026-04-06T23:59:59'),
// };

export function isPromotionActive(config: PromotionConfig): boolean {
  const now = new Date();
  return now >= config.activeFrom && now <= config.activeTo;
}

export function matchesPromotionAudience(
  audience: PromotionAudience | undefined,
  featureConfig: FeatureConfig | null,
): boolean {
  if (featureConfig === null) return false;
  if (audience === undefined) return true;
  if (audience.requireAll !== undefined && !audience.requireAll.every(k => featureConfig[k])) return false;
  if (audience.requireAny !== undefined && !audience.requireAny.some(k => featureConfig[k])) return false;
  if (audience.exclude !== undefined && audience.exclude.some(k => featureConfig[k])) return false;
  if (audience.onlyWhenNoFeatures && !isEmptyFeatureConfig(featureConfig)) return false;
  return true;
}
